// extracted by mini-css-extract-plugin
export default {"messagesContent":"CarrierChatPage_messagesContent__DU0yu"};